module.exports = __webpack_public_path__ + "img/ad-1.8604dc66.png";